import { observer } from 'mobx-react';
import * as React from 'react';
import { Loader } from './Loader';

export interface INothingHereProps {
    readonly className?: string;
    readonly label?: string;
    readonly icon?: React.ReactNode;
    readonly empty: boolean;
    readonly loading: boolean;
    readonly loadingMessage?: string;
    readonly forceLoaderOnLoad?: boolean;
}

@observer
export class NothingHere extends React.Component<INothingHereProps> {
    public render() {
        const { empty, loading, className, icon, label, loadingMessage, forceLoaderOnLoad } = this.props;
        const showLoader = forceLoaderOnLoad ? loading : loading && empty;

        if (showLoader) {
            return (
                <div className={'col-12 text-center p-4 text-gray-light ' + className}>
                    <Loader loading={true} message={loadingMessage} showSpinner />
                </div>
            );
        } else if (empty) {
            return (
                <div className={'col-12 text-center p-4 text-gray-light ' + className}>
                    {icon && (
                        <div className="d-block mb-2">
                            <em className={'nothing-icon '}>{icon}</em>
                        </div>
                    )}

                    <p>{label ?? "Oops there's nothing here!"}</p>
                </div>
            );
        } else {
            return null;
        }
    }
}
